import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetCompanyByIdQuery } from "../slices/companySlice";
import { Button, Card, Col, ListGroup, Row } from "react-bootstrap";

const ViewCompanyDetailsScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const {
    data: companyDetails,
    isLoading,
    error,
    refetch,
  } = useGetCompanyByIdQuery({
    token: userInfo?.token,
  });

  return (
    <>
      <Row className="mb-3">
        <Col>
          <Button variant="primary" onClick={() => navigate("/")}>
            Back
          </Button>
        </Col>
      </Row>

      <h5>View Company Details</h5>

      <Row>
        <Col md={5}>
          <Card>
            <ListGroup>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Company Name:</strong>
                  </Col>
                  <Col>
                    <strong>{companyDetails?.companyName}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Company Id:</strong>
                  </Col>
                  <Col>
                    <strong>{companyDetails?._id}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Category:</strong>
                  </Col>
                  <Col>
                    <strong>{companyDetails?.companyCategory}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong> Address:</strong>
                  </Col>
                  <Col>
                    <strong>{companyDetails?.companyAddress}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>City</strong>
                  </Col>
                  <Col>
                    <strong>{companyDetails?.companyCity}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Pincode:</strong>
                  </Col>
                  <Col>
                    <strong>{companyDetails?.companyPincode}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>State</strong>
                  </Col>
                  <Col>
                    <strong>{companyDetails?.companyState}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Contact:</strong>
                  </Col>
                  <Col>
                    <strong>{companyDetails?.companyContact}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Seperate PltformFee:</strong>
                  </Col>
                  <Col>
                    <strong>
                      {companyDetails?.separatePlaformFee ? "Yes" : "No"}
                    </strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>PlatformFee:</strong>
                  </Col>
                  <Col>
                    <strong>₹{companyDetails?.platformFee}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>

              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Operation Status</strong>:
                  </Col>
                  <Col>
                    <strong>
                      {companyDetails?.operationStatus ? "Yes" : "No"}
                    </strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Added By:</strong>
                  </Col>
                  <Col>
                    <strong>{companyDetails?.addedBy}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ViewCompanyDetailsScreen;
